/**
 * Everspring — Product Card Bundle Preview
 * Fetches bundle components for all product cards via a single
 * Storefront API batch query and renders compact previews.
 */
function initBundleCards() {
  var token = window.__esBundleToken;
  var shopDomain = window.__esBundleShop;
  if (!token || !shopDomain) { console.log('[BundleCards] No token or shop domain'); return; }

  var apiVersion = '2025-01';
  var cards = document.querySelectorAll('[data-bundle-product-id]');
  console.log('[BundleCards] Found', cards.length, 'cards');
  if (!cards.length) return;

  // Collect unique product IDs
  var idSet = {};
  cards.forEach(function(card) {
    idSet[card.getAttribute('data-bundle-product-id')] = true;
  });
  var productIds = Object.keys(idSet);
  if (!productIds.length) return;

  // Shopify Storefront API allows a limited number of aliases per query.
  // 30 has been stable, so we batch requests in chunks of 30.
  var BATCH_SIZE = 30;

  function buildQuery(ids) {
    var productQueries = ids.map(function(id, i) {
      return 'p' + i + ': product(id: "gid://shopify/Product/' + id + '") { id variants(first:1) { nodes { components(first:20) { nodes { quantity productVariant { product { title featuredImage { url } } } } } } } }';
    });
    return '{ ' + productQueries.join(' ') + ' }';
  }

  function fetchBatch(ids) {
    return fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: buildQuery(ids) })
    })
    .then(function(res) { return res.json(); })
    .catch(function() { return null; });
  }

  // Split into batches of BATCH_SIZE
  var batches = [];
  for (var bi = 0; bi < productIds.length; bi += BATCH_SIZE) {
    batches.push(productIds.slice(bi, bi + BATCH_SIZE));
  }

  Promise.all(batches.map(fetchBatch))
  .then(function(responses) {
    // Merge all responses into one bundleMap
    var bundleMap = {};

    responses.forEach(function(data) {
      if (!data || !data.data) return;

      Object.keys(data.data).forEach(function(key) {
        var product = data.data[key];
        if (!product || !product.variants || !product.variants.nodes.length) return;
        var components = product.variants.nodes[0].components;
        if (!components || !components.nodes.length) return;

        var numericId = product.id.replace('gid://shopify/Product/', '');
        var items = [];
        var totalPlants = 0;
        var uniqueProducts = {};

        components.nodes.forEach(function(comp) {
          var title = comp.productVariant.product.title;
          if (!uniqueProducts[title]) {
            uniqueProducts[title] = {
              title: title,
              image: comp.productVariant.product.featuredImage ? comp.productVariant.product.featuredImage.url : null,
              quantity: 0
            };
          }
          uniqueProducts[title].quantity += comp.quantity;
          totalPlants += comp.quantity;
        });

        bundleMap[numericId] = {
          items: Object.values(uniqueProducts),
          totalPlants: totalPlants,
          uniqueCount: Object.keys(uniqueProducts).length
        };
      });
    });

    // Render into cards
    cards.forEach(function(card) {
      var pid = card.getAttribute('data-bundle-product-id');
      var bundle = bundleMap[pid];
      if (!bundle) return;

      // Update the bottom bundle-summary line: prepend "X soorten · "
      var productCard = card.closest('.es-product-card');
      if (productCard) {
        var summarySlot = productCard.querySelector('[data-bundle-unique-summary]');
        if (summarySlot && bundle.uniqueCount > 0) {
          summarySlot.textContent = bundle.uniqueCount + ' soorten · ';
          summarySlot.hidden = false;
        }
      }

      var html = '<div class="es-product-card__bundle-items">';

      bundle.items.forEach(function(item) {
        html += '<div class="es-product-card__bundle-item">';
        if (item.image) {
          html += '<div class="es-product-card__bundle-img"><img src="' + item.image + '&width=60" alt="" width="24" height="24" loading="lazy"></div>';
        }
        html += '<span class="es-product-card__bundle-name">' + item.title + '</span>';
        html += '</div>';
      });

      html += '</div>';
      card.innerHTML = html;
      card.style.display = '';
    });
  })
  .catch(function(err) {
    // Silently fail — cards just won't show bundle info
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleCards);
} else {
  initBundleCards();
}

// Expose globally so other scripts (facets.js, etc.) can trigger a re-init
window.esReinitBundleCards = initBundleCards;

// Re-run automatically when the DOM changes (e.g. after filter/sort AJAX updates
// replace the collection grid). Uses a MutationObserver with a debounce to avoid
// excessive refetches during rapid DOM changes.
(function () {
  if (typeof MutationObserver === 'undefined') return;

  var reinitTimer = null;
  function scheduleReinit() {
    if (reinitTimer) clearTimeout(reinitTimer);
    reinitTimer = setTimeout(function () {
      initBundleCards();
    }, 120);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.addedNodes && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          // If the added node is (or contains) a bundle product card, reinit
          if (node.matches && node.matches('[data-bundle-product-id]')) {
            scheduleReinit();
            return;
          }
          if (node.querySelector && node.querySelector('[data-bundle-product-id]')) {
            scheduleReinit();
            return;
          }
        }
      }
    }
  });

  // Start observing once the body exists
  function startObserving() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
